import React, { useState, useEffect, Fragment } from "react";
import { Row, Col, Table, Pagination, Button, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import * as moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "../../hooks/useTranslation";
import apiService from "../../services/api.service";
import { OrderStatus } from "../../data/enums";
import { showToast } from "../../Redux/toastReducer";

/**
 * Orders table component for My Account page, used in both company and customer accounts with some variations.
 */

function OrdersTable({ thisAccountCustomer, chainId, isCompanyUser }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const companyUser = useSelector((state) => state.company.companyUser);
  const tableTitle = isCompanyUser ? t("MyVouchers") : t("YourOrders");

  const [allOrders, setAllOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);       // API page — triggers re-fetch
  const [pages, setPages] = useState(1);                   // total API pages (from totalCount)
  const pageSize = 10;
  const [selectedOrderStatus, setSelectedOrderStatus] = useState("-1");
  

  const OrdersWithoutInProgress = () => {
    return `
    ${OrderStatus.Used},
    ${OrderStatus.Pending},
    ${OrderStatus.Redeemed},
    ${OrderStatus.Reserved},
    ${OrderStatus.Cancelled},
    ${OrderStatus.UsedPartially},
    ${OrderStatus.RedemptionPending},
    ${OrderStatus.CancellationPending},
    ${OrderStatus.CancellationRefunded},`
  }

  const getOrderRedeemItem = (allOrdersWithoutInProgress) => {
    for (var i = 0; i < allOrdersWithoutInProgress.length; i++) {
      let currentOrder = allOrdersWithoutInProgress[i];
      if (currentOrder.orderId && currentOrder.products && currentOrder.products.length && currentOrder.products[0].productId > 0) {
        apiService.getOrderRedeemItems(chainId, currentOrder.orderId, currentOrder.products[0].productId).then(
          (response) => {
            if (response.data && !response.data.HasErrors && response.data.data && response.data.data.length > 0) {
              currentOrder.RedeemItem = response.data.data;
              for (var i = 0; i < currentOrder.RedeemItem.length; i++) {
                let curItem = currentOrder.RedeemItem[i];
                if (curItem.propertyId > 0) {
                  curItem.propertyName = curItem.propertyId;
                  apiService.getPropertyById(chainId, curItem.propertyId).then(
                    (response) => {
                      if (response.data && !response.data.HasErrors && response.data.data && response.data.data.length > 0 && response.data.data[0].propertyTranslations.length > 0) {
                        curItem.propertyName = response.data.data[0].propertyTranslations[0].propertyName;
                      }
                      setTimeout(() => { setAllOrders(allOrdersWithoutInProgress); }, 900);
                    },
                    (error) => {}
                  );
                }
              }
            }
          },
          (error) => {}
        );
        setTimeout(() => { setAllOrders(allOrdersWithoutInProgress); }, 1000);
      }
    }
  }

  const getOrders = (mycustomerId, ordersStatus = null) => {
    let request = {
        chainId: chainId,
        pageSize: pageSize,
        groupOrders: "false",
        pageNumber: currentPage,
        orderStatusIdsCSV: OrdersWithoutInProgress(),
    
        //customer values
        customerId: mycustomerId
      }

    if (isCompanyUser){
      request = {
        ...request,

        //company values
        companyId: companyUser.companyId,
        orderByColumn: "OrderPlacementDate",
        orderStatusIdsCSV: ordersStatus,

        //reset customer
        customerId: null
      }
    }

    apiService.getOrders(request).then(
        (response) => {
          if (response.data && !response.data.HasErrors && response.data.data && response.data.data.length > 0) {
            let allOrdersWithoutInProgress = response.data.data;
            getOrderRedeemItem(allOrdersWithoutInProgress); // get redeem item for each order and then set orders with redeem item 
            setPages(response.data.data[0].totalCount / pageSize);
          } else {
            setAllOrders([]);
          }
        },
        (error) => {}
    );

  }

  useEffect(() => {
    setAllOrders([]);
    if (thisAccountCustomer) {
      getOrders(thisAccountCustomer.customerId);
    }
  }, [currentPage, thisAccountCustomer]);


  const renderPaginationItems = () => {
    const items = [];

    for (let number = 1; number <= pages; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => setCurrentPage(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    return items;
  };

  const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return moment(result).format("DD/MM/YYYY");
  };

  const getTotalRedeemedPerOrder = (RedeemItem, originalPrice, currency) => {
    if (RedeemItem) {
      let totalRedeemedAmount = RedeemItem.reduce((a, v) => a = a + v.redeemAmount, 0);
      let lefttoredeem = originalPrice - totalRedeemedAmount;
      return lefttoredeem + " " + currency;
    }
  }

  const getStatusNameById = (id) => {
    let status = "";
    switch (id) {
      case -1: status = t("AllOrders"); break;
      case 0: status = t("Cancelled"); break;
      case 1: status = t("Reserved"); break;
      case 2: status = t("InProcess"); break;
      case 3: status = t("Used"); break;
      case 4: status = t("Cancellanionpending"); break;
      case 5: status = t("Cancellanionrefunded"); break;
      case 6: status = t("Redemptionpending"); break;
      case 7: status = t("Redeemed"); break;
      case 8: status = t("UsedPartially"); break;
      case 9: status = t("Pending"); break;
      default: status = t("Reserved");
    }
    return status;
  };

  const getRedeemHistory = (RedeemItem, originalPrice, currency) => {
    if (RedeemItem) {
      return RedeemItem.map((currentItem, ind) => (
        <div key={ind + "-or"} className={"hist-row-" + currentItem.orderId + " hidden"}>
          <div className="redeem-history">
            <span>{t("CreatedOn") + " " + moment(currentItem.createdOn).format("DD/MM/YYYY")}</span>
            <span>{t("RedeemAmount") + " " + currentItem.redeemAmount + " " + currency}</span>
            <span>{currentItem.pmsReference ? t("PmsReference") + " " + currentItem.pmsReference : ""}</span>
            <span>{currentItem.propertyName ? t("InHotel") + " " + currentItem.propertyName : ""}</span>
          </div>
        </div>
      ));
    }
  };

  const openHitoreyRow = (clickedRow) => {
    let element = document.getElementsByClassName(clickedRow);
    if (element) {
      for (var i = 0; i < element.length; i++) {
        if (element[i].classList.contains("hidden")) {
          element[i].classList.remove("hidden");
        } else {
          element[i].classList.add("hidden");
        }
      }
    }
  };

  const handleOrderStatusChange = (val) => {
    setSelectedOrderStatus(val);

    if(val === "-1"){ val = null; }
    getOrders(null, val);
  }

  // const handleOrderSearch = () =>{
  //   //setFilteredCurrentPage(1);
  //   const searchInput = document.getElementById("search-input").value;

  //   const containsSearch = (value, search) => {
  //     if (value == null) return false;

  //     // string / number / boolean
  //     if ( typeof value === "string" || typeof value === "number" || typeof value === "boolean" ) {
  //       return value.toString().trim().toLowerCase().includes(search);
  //     }

  //     // array
  //     if (Array.isArray(value)) {
  //       return value.some(item => containsSearch(item, search));
  //     }

  //     // object
  //     if (typeof value === "object") {
  //       return Object.values(value).some(v =>
  //         containsSearch(v, search)
  //       );
  //     }

  //     return false;
  //   };

  //   setFilteredOrders(allOrders.filter(order =>
  //     containsSearch(order, searchInput)
  //   ));
  // }

  const sendOrderEmailNotification = (orderId) =>{
    let request = {
        "orderIds": [ orderId ],
        "dueTime": moment(new Date(Date.now() + 1 * 60 * 1000)).format("YYYY-MM-DDTHH:mm:ss") //1 minute from now
    }
    
    apiService.setRescheduleGifteeNotifications(request).then(
      (response) => {
        if (response.data && !response.data.HasErrors){
          dispatch(showToast({ message: t("EmailNotificationSentSuccess"), severity: "success" }));
        }
      },
      (error) => {
        dispatch(showToast({ message: t("EmailNotificationSentFailed"), severity: "error" }));
      }
    )
  }


  return (
    <>
      <h4 aria-label={tableTitle}>{tableTitle}</h4>
      {
        isCompanyUser &&
        <Row>
          <Col className="flex-row d-flex gap-3">
            {/* <InputGroup className="search-vouchers searchbar-table d-none" style={{"direction": "ltr"}}>
              <Button variant="outline-secondary" onClick={handleOrderSearch} aria-label={t("Search")} className="search-btn">
                <img src="../images/search-icon.svg" alt={t("Search")} alt="" />
              </Button>
              <Form.Control id="search-input" className="border-0" aria-label={t("Search")} style={{"direction": "rtl"}} placeholder={t("Search")} />
            </InputGroup> */}

            <ToggleButtonGroup type="radio" name="orderStatusSelect" className="order-status-select" value={selectedOrderStatus} onChange={handleOrderStatusChange}>
              <ToggleButton id="-1" value="-1" variant="outline-primary" className="order-status-btn" aria-label={ getStatusNameById(-1) } > { getStatusNameById(-1) } </ToggleButton>
              <ToggleButton id="1" value="1" variant="outline-primary" className="order-status-btn"   aria-label={ getStatusNameById(1) } > { getStatusNameById(1) } </ToggleButton>
              <ToggleButton id="0" value="0" variant="outline-primary" className="order-status-btn"   aria-label={ getStatusNameById(0) } > { getStatusNameById(0) } </ToggleButton>
            </ToggleButtonGroup>
          </Col>
        </Row>
        
      }
      <Table hover className="ordersTable" responsive>
        <thead>
          <tr>
            <th>{t("OrderNum")}</th>
            <th>{t("VoucherName")}</th>
            <th>{t("VoucherNum")}</th>
            <th>{t("Date")}</th>
            <th>{t("VoucherValue")}</th>
            <th>{t("IsSuedTo")}</th>
            <th>{t("VoucherExpiration")}</th>
            <th>{t("VoucherLeftToRedeem")}</th>
            <th>{t("VoucherStatus")}</th>
            { isCompanyUser && <th> &nbsp; </th> /*for resend email button */ }
          </tr>
        </thead>
        <tbody>
          {
             allOrders.map((currentOrder, index) => (
              <Fragment key={index}>
                {currentOrder.products?.map((currentProduct, ind) => (
                  <Fragment key={ind}>
                    <tr
                      className="order-item "
                      onClick={(e) => openHitoreyRow("hist-row-" + currentOrder.orderId)}
                    >
                      <td aria-label={t("OrderNum") + currentOrder.orderId.toString().split("").join(" ")}>
                        {currentOrder.orderId}
                      </td>
                      <td aria-label={t("VoucherName") + currentProduct.productShortDescription ? currentProduct.productShortDescription : currentProduct.productName}>
                        {currentProduct.productShortDescription ? currentProduct.productShortDescription : currentProduct.productName}
                      </td>
                      <td aria-label={t("VoucherNum") + currentOrder.voucherNumber.toString().split("").join(" ")}>
                        {currentOrder.voucherNumber}
                      </td>
                      <td aria-label={"תאריך הרכישה" + moment(currentOrder.orderPlacementDate).format("DD/MM/YYYY")}>
                        {moment(currentOrder.orderPlacementDate).format("DD/MM/YYYY")}
                      </td>
                      <td aria-label={t("VoucherValue") + currentProduct.price + " " + currentProduct.currencyCode.replace("ILS", "₪")}>
                        {currentProduct.price + " " + currentProduct.currencyCode.replace("ILS", "₪")}
                      </td>
                      <td aria-label={t("IsSuedTo") + currentOrder.gifteeName ? currentOrder.gifteeName : currentOrder.customer.customerFirstName + " " + currentOrder.customer.customerLastName}>
                        {currentOrder.gifteeName ? currentOrder.gifteeName : currentOrder.customer.customerFirstName + " " + currentOrder.customer.customerLastName}
                      </td>
                      <td aria-label={t("VoucherExpiration") + currentProduct.duration ? addDays(currentOrder.orderPlacementDate, currentProduct.duration) : currentProduct.productExpiryDate ? moment(currentProduct.productExpiryDate).format("DD/MM/YYYY") : ""}>
                        {currentProduct.duration || currentProduct.productExpiryDate ? (
                          <Row>
                            <Col className="expdate">
                              <span>
                                {currentProduct.duration
                                  ? addDays(currentOrder.orderPlacementDate, currentProduct.duration)
                                  : currentProduct.productExpiryDate
                                  ? moment(currentProduct.productExpiryDate).format("DD/MM/YYYY")
                                  : ""}
                              </span>
                            </Col>
                          </Row>
                        ) : null}
                      </td>
                      <td aria-label={t("VoucherLeftToRedeem") + getTotalRedeemedPerOrder(currentOrder.RedeemItem, currentProduct.price, currentProduct.currencyCode.replace("ILS", "₪"))}>
                        <span className="clickable">
                          {getTotalRedeemedPerOrder(currentOrder.RedeemItem, currentProduct.price, currentProduct.currencyCode.replace("ILS", "₪"))}
                        </span>
                      </td>
                      <td aria-label={t("VoucherStatus") + getStatusNameById(currentOrder.orderStatusId)}>
                        {getStatusNameById(currentOrder.orderStatusId)}
                      </td>
                      {
                        isCompanyUser &&
                          <td valign="middle">
                            <Button variant="secondary" className="account-btn email-resend" onClick={() => sendOrderEmailNotification(currentOrder.orderId)}><img src="../images/email-resend.svg" alt=""/></Button>
                          </td>
                      }
                    </tr>
                    <tr>
                      <td colSpan={isCompanyUser ? 10 : 9}>
                        {getRedeemHistory(currentOrder.RedeemItem, currentProduct.price, currentProduct.currencyCode.replace("ILS", "₪"))}
                      </td>
                    </tr>
                  </Fragment>
                ))}
              </Fragment>
            ))
          }
        </tbody>
      </Table>
      {!!allOrders.length && (
        <Row className="justify-content-start">
          <Pagination className="justify-content-center">
            <Pagination.First disabled={currentPage === 1} onClick={() => setCurrentPage(1)} />
            <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage(pages - 1)} />
            {renderPaginationItems()}
            <Pagination.Next disabled={currentPage === pages} onClick={() => setCurrentPage(pages + 1)} />
            <Pagination.Last disabled={currentPage === pages} onClick={() => setCurrentPage(pages)} />
          </Pagination>
        </Row>
      )}
    </>
  );
}

export default OrdersTable;
